import { Menu, MenuItem } from "@mui/material"
import { observer } from "mobx-react-lite"
import { useRef } from "react"
import { useMainStore } from "../../imacros-generator/store"
import TableStore from "./store"

type Props = {
  store: TableStore
}

const EditorCell = observer(({ store }: Props) => {

  const mainStore = useMainStore()
  const divRef = useRef(null)

  const column = store.selectedCell && (mainStore.scheme.tableColumns as any)[store.selectedCell[1]]
  const value =  store.selectedCell && (mainStore.arrayValues[store.selectedCell[0]] as any)[store.selectedCell[1]]
  
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!store.selectedCell) return
    mainStore.setArrayValue(store.selectedCell[0], store.selectedCell[1], e.target.value)
  }

  const onChangeValue = (val: string) => {
    if (!store.selectedCell) return
    mainStore.setArrayValue(store.selectedCell[0], store.selectedCell[1], val)
    store.setMenuOpen(false)
  }
  
  if (column?.values) {
    return (
      <div 
        ref={divRef} 
        style={{ paddingLeft: 16, width: "100%" }} 
        onClick={(e) => e.currentTarget === e.target && store.setMenuOpen(true)}
      >
        { value  }
        <Menu 
          anchorEl={divRef.current} 
          open={store.menuOpen} 
          anchorOrigin={{ horizontal: "left", vertical: "top" }}
          PaperProps={{ style: { marginTop: -8 } }}
          onClose={() => store.setMenuOpen(false)}
          sx={{ 
            '.MuiMenuItem-root': { pr: 4 },
          }}
        >
          {(column.values as string[]).map((val, index) => (
            <MenuItem key={index} onClick={() => onChangeValue(val)}>{val}</MenuItem>
          ))}
        </Menu>
      </div>
    )
  }

  return (
    <input id="table-input" onChange={onChange} value={value}/>
  )

})

export default EditorCell